<template>
  <div class="content-container flex-column">
    <div class="grid-x toolbar fixed">
      <div class="cell auto">
        <h4 class="no-margin toolbar-title">Innstillinger - {{name}}</h4>
      </div>

      <div class="cell shrink">
        <router-link :to="{ name: 'InstillingerList' }" class="button primary transparent">Gå tilbake</router-link>
      </div>
    </div>

    <router-link :to="{ name: name + 'Add'}" class="button action fixed right" v-if="perms.create">
      Ny {{name}}
    </router-link>

    <TheLoader :active="loading"/>

    <table v-if="!loading" class="large fixed visible" :class="{'clickable': perms.update}" style="width: 100%">
      <thead>
        <tr>
          <th v-for="(heading, index) in keys" v-bind:key="index">
            <span v-if="name === 'Vare' && heading === 'twentyfourseven_product_id'">
               247 Synkronisert
            </span>
            <span v-else-if="name === 'Kategori' && heading === 'twentyfourseven_category_id'">
               247 Synkronisert
            </span>
            <span v-else-if="name === 'Lokasjon' && heading === 'object_count'">
              Antall obj.
            </span>
            <span v-else>
              {{heading}}
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in items" v-bind:key="item.id" @click="editItem(item)">
          <td v-for="(heading, index) in keys" :key="index">
            <span v-if="heading === 'Expertavdeling'">
              {{printExpertAvdeling(item)}}
            </span>
            <span v-else-if="heading === 'Bilagsart'">
              <span v-if="item[heading] === 'K'">Kjøp</span>
              <span v-else-if="item[heading] === 'S'">Salg</span>
              <span v-else>Alle</span>
            </span>
            <span v-else-if="heading === 'Status'">
              <span v-if="item[heading] === 'true' || item[heading] === true">Aktiv</span>
              <span class="opacity-60" v-else>Inaktiv</span>
            </span>
            <span v-else-if="heading === 'Aktiv'">
              <span v-if="item[heading] === 1">Aktiv</span>
              <span class="opacity-60" v-else>Inaktiv</span>
            </span>
            <span v-else-if="name === 'Vare' && heading === 'twentyfourseven_product_id'">
              <span v-if="['OBJEKT', 'SALÆR', 'OPPGJØR', 'BKH'].includes(item.Varekode) || item.twentyfourseven_products.length > 0" class="avatar name left green">Ja <span class="name">Synkronisert med 247</span></span>
              <span v-else class="avatar name left red">Nei <span class="name">Ikke synkronisert med 247</span></span>
            </span>
            <span v-else-if="name === 'Kategori' && heading === 'twentyfourseven_category_id'">
              <span v-if="item[heading]" class="avatar name left green">Ja <span class="name">Synkronisert med 247</span></span>
              <span v-else class="avatar name left red">Nei <span class="name">Ikke synkronisert med 247</span></span>
            </span>
            <span v-else-if="name === 'Lokasjon' && heading === 'object_count'">
              {{item[heading] || 0}}
            </span>
            <span v-else-if="name === 'Utelagringsdager' && heading === 'StartDate'">
              {{formatDate(item[heading])}}
            </span>
            <span v-else-if="name === 'Utelagringsdager' && heading === 'EndDate'">
              {{formatDate(item[heading])}}
            </span>
            <span v-else>
              {{item[heading]}}
            </span>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="pagination-container"  v-if="pages > 1">
      <paginate v-model="page"
        :page-count="pages"
        :page-range="11"
        :click-handler="setPage"
        :container-class="'pagination'"
        :prev-text="paginationArrow"
        :next-text="paginationArrow"
        :prev-class="'prev'"
        :next-class="'next'"
        >
      </paginate>
    </div>
  </div>
</template>

<script>
import InstillingerService from '@/services/InstillingerService'
import moment from 'moment'

export default {
  props: {
    name: {
      type: String,
      required: true
    },
    keys: {
      type: Array,
      required: true
    },
    perms: {
      type: Object,
      required: false,
      deafult () {
        return {
          create: false,
          update: false
        }
      }
    },
    servicename: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      page: 1,
      pages: 1,
      items: [],
      loading: false
    }
  },
  beforeRouteUpdate: function (to, from, next) {
    this.page = to.query.page ? parseInt(to.query.page) : 1

    this.fetch(next)
  },
  created () {
    this.page = this.$route.query.page ? parseInt(this.$route.query.page) : 1

    this.fetch()
  },
  methods: {
    fetch: function (callback) {
      this.loading = true

      let service = InstillingerService(this.servicename)

      service.index(this.page)
        .then((response) => {
          this.pages = response.headers['x-paging-pagecount'] ? parseInt(response.headers['x-paging-pagecount']) : 1
          this.items = response.data

          if (callback) {
            callback()
          }
        })
        .catch(() => {
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste inn liste')
        })
        .then(() => {
          this.loading = false
        })
    },
    setPage: function (pageNum) {
      this.$router.push({ name: this.$route.name, query: {page: pageNum} })
    },
    editItem: function (item) {
      if (this.perms.update) {
        this.$router.push({name: this.name + 'Edit', params: {id: item[this.keys[0]]}})
      }
    },
    printExpertAvdeling: function (item) {
      let retval = []

      item.expertavdeling.forEach((i) => {
        retval.push(i.Navn)
      })

      return retval.join(', ')
    },
    formatDate: function (date) {
      return moment(new Date(date)).format('DD.MM.YYYY')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Instillinger/InstillingerCustomList.vue